import React from 'react';
import styles from './AboutHero.module.css';

function AboutHero({ isHVisible, isP1Visible, isP2Visible }) {
    return (
        <section className={`${styles.aboutHero} navbarOffsetHeight`}>
            <div className={styles.aboutHeroBox}>
                <div className={styles.aboutHeroLeft}>
                    <img src={`${process.env.PUBLIC_URL}/Logo.png`} alt="hero" className={styles.logo} />
                </div>
                
                <div className={styles.aboutHeroRight}>
                    <h1 className={`${styles.title} ${isHVisible ? styles.aboutVisible : ''}`}>Pick & Sell</h1>
                    <p className={`${styles.subtitle} ${isP1Visible ? styles.aboutVisible : ''}`}>중고 기타 거래의 새로운 기준</p>
                    <p className={`${styles.subtitle} ${isP2Visible ? styles.aboutVisible : ''}`}>픽앤셀을 소개합니다</p>
                    <div className={styles.imgBox}>
                        <img
                            src={`${process.env.PUBLIC_URL}/arrow_double_bottom.png`}
                            alt="arrow_double"
                            className={`${styles.subtitle} ${isP2Visible ? styles.aboutVisible : ''}`}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutHero;
